import type { BarIndex } from '../../../theme/tokens';
import { UTIL_BAND_BAR_INDEX, type UtilisationBand } from '../../../utils/utilisation';

/**
 * Dashboard utilisation palette for the server's band, from the shared soft
 * `bars[N]` fills (mint/moss/rose) so it cannot drift from the Planning Board
 * heatmap and Reports bars:
 *
 *   unassigned → pale blue (bar-1)  text: secondary
 *   under      → pale mint (bar-2)  text: secondary
 *   optimal    → pale moss (bar-5)  text: success
 *   over       → pale rose (bar-6)  text: danger
 *
 * The soft fill carries the band's emotional weight; the saturated tone
 * is reserved for the numeric label to its right so the eye lands on
 * "82%" not the bar itself.
 */
export type UtilToneTextColor =
  | 'text.secondary'
  | 'success.main'
  | 'error.main';

export interface UtilTone {
  fillIdx: BarIndex;
  textColor: UtilToneTextColor;
}

const BAND_TEXT_COLOR: Record<UtilisationBand, UtilToneTextColor> = {
  unassigned: 'text.secondary',
  under: 'text.secondary',
  optimal: 'success.main',
  over: 'error.main',
};

export function utilTone(band: UtilisationBand): UtilTone {
  return { fillIdx: UTIL_BAND_BAR_INDEX[band], textColor: BAND_TEXT_COLOR[band] };
}
